import { importTransformation as importTransformationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & { importedTransformation }

export const importTransformation = ({
    importedTransformation,
    eventEmitter,
}: Props) => {
    importTransformationDiagram(importedTransformation);
    eventEmitter.emit(Event.updateDataTransformation);
};
